import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  FinanceIcon,
  AccountsReceivable1,
  AccountsReceivable2,
  AccountsReceivable3,
  AccountsPayable1,
  AccountsPayable2,
  AccountsPayable3,
  TaxationControls1,
  TaxationControls2,
  TaxationControls6,
} from '../../assets';

const FinancePageUS = () => {
  const productData = {
    productName: 'Finance',
    tagline: 'Freight Finance Software for US Freight Forwarders',
    metaDescription: 'Freight finance software for US freight forwarders and NVOCCs: USD invoicing from shipment data, per-shipment P&L, approval workflows, accounts payable management, and bank reconciliation in one platform.',
    description: 'Full financial control for your US freight forwarding business: invoicing from shipment data, per-job profitability tracking, configurable approval workflows, accounts payable management, and bank reconciliation in one platform.',
    icon: FinanceIcon,
    pageUrlOverride: 'https://shipmnts.com/us/products/finance',
    currency: 'USD',
    features: [
      {
        title: 'Integrated Invoicing from Shipments',
        description: 'Generate invoices automatically from shipment data with accurate charge breakdowns: eliminating manual re-entry and reducing billing errors.',
        image: AccountsReceivable1,
      },
      {
        title: 'Automated Collection Reminders',
        description: 'Send automated payment reminders and track collection status across your client base.',
        image: AccountsReceivable2,
      },
      {
        title: 'AR with Profitability Insights',
        description: 'Track receivables with built-in profitability analysis per customer and shipment.',
        image: AccountsReceivable3,
      },
      {
        title: 'Integrated Purchase Invoice Posting',
        description: 'Match vendor invoices with shipment costs and post to accounts payable: with automated validation.',
        image: AccountsPayable1,
      },
      {
        title: 'Bulk Purchase Booking System',
        description: 'Book multiple vendor invoices in bulk with automated validation and matching.',
        image: AccountsPayable2,
      },
      {
        title: 'AP Tracking & Monitoring',
        description: 'Track payables aging, payment schedules, and vendor performance in one view.',
        image: AccountsPayable3,
      },
      {
        title: 'Tax-ready Reporting',
        description: 'Generate tax-ready financial reports, track expenses by cost center, and maintain audit-ready records for your US freight operations.',
        image: TaxationControls1,
      },
      {
        title: 'Profit and Loss with EBITDA Metrics',
        description: 'View real-time P&L statements with EBITDA tracking at shipment, branch, and company level.',
        image: TaxationControls2,
      },
      {
        title: 'Bank Reconciliation Suite',
        description: 'Reconcile bank statements automatically with matching algorithms, flagging unmatched items for review.',
        image: TaxationControls6,
      },
    ],
    faqs: [
      {
        question: 'Can Shipmnts generate invoices automatically from shipment data?',
        answer: 'Yes. Shipmnts integrates billing directly with shipment operations: invoices are generated from job data with accurate charge breakdowns, eliminating manual re-entry and reducing billing errors for US freight forwarders.',
      },
      {
        question: 'Can I track profitability per shipment in Shipmnts?',
        answer: 'Yes. Shipmnts provides per-job P&L visibility with EBITDA-level metrics, letting you see revenue, costs, and margin on every shipment in real time: by lane, carrier, or customer.',
      },
      {
        question: 'Does Shipmnts support configurable approval workflows for invoices?',
        answer: 'Yes. Shipmnts includes configurable approval workflows for invoices and payments: set by branch and role. Finance teams can review and approve before release, with credit control policies that hold document releases for high-risk customers.',
      },
      {
        question: 'Does Shipmnts have bank reconciliation?',
        answer: 'Yes. Shipmnts includes a bank reconciliation suite that matches bank statement entries against invoices and payments automatically, flagging unmatched items for review.',
      },
      {
        question: 'Is Shipmnts suitable for US NVOCCs managing multi-party billing?',
        answer: 'Yes. Shipmnts supports multi-party billing across agent, shipper, and carrier relationships: with separate House and Master billing, credit notes, and debit notes: all linked to the underlying shipment job.',
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default FinancePageUS;
